import { langType } from './../types'

const lang: langType = {
  tel: 'tel',
  team: 'department',
  nickname: 'nickname',
  city: 'city',
  address: 'address',
  baseInfo: 'user info',
  id: 'accrount userid',
  passwordsafe:'password safe',
  brithday: 'Brithday',
  updateBaseInfo: 'Update base info',
  add: 'Add',
  workgroup:'workgroup',
  selectSkillAndInterst: 'Please select your skills and hobby',
  saveAndClose: 'Save and close',
  adminTips: 'Please input skills and hobby,use ; to division',
  skillAdmin: 'Skill tags admin',
  needSkills: 'Skills required!'
}

export default lang
